import { render } from "./carimage2.vue?vue&type=template&id=6d8886a2&scoped=true"
import script from "./carimage2.vue?vue&type=script&lang=js"
export * from "./carimage2.vue?vue&type=script&lang=js"

import "./carimage2.vue?vue&type=style&index=0&id=6d8886a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8886a2"]])

export default __exports__